import { EditorialType, IconLiveTN } from '@news-mono/component-library'
import React, { FC } from 'react'
import { Classification } from './Classification'
import { Bullet } from './Bullet'
import { TopicLink } from './Topic'
import { Author, AuthorLink } from './Author'
import { TopicBylineWrapper } from './TopicBylineWrapper'
import CommentsCount from './CommentsCount'
import { StyledLiveClassificationContainer } from './Byline.styled'
import { FeaturePill } from '../../../../../pills/FeaturePill'

export interface BylineProps {
    editorialType?: EditorialType
    topicLink: string
    topicTitle: string
    bylineText: string
    bylineLink?: string
    allowCommenting: boolean
    articleUrl: string
    isShorthand?: boolean
}

export const Byline: FC<BylineProps> = ({
    editorialType,
    topicLink,
    topicTitle,
    bylineText,
    bylineLink,
    allowCommenting,
    articleUrl,
    isShorthand,
}) => {
    return (
        <TopicBylineWrapper>
            {isShorthand && <FeaturePill />}
            {editorialType && (
                <>
                    <Classification type={editorialType}>
                        {editorialType === EditorialType.Live && (
                            <StyledLiveClassificationContainer>
                                <IconLiveTN />
                            </StyledLiveClassificationContainer>
                        )}
                        {editorialType}
                    </Classification>
                    <Bullet removeMargin={true} />
                </>
            )}

            <TopicLink to={topicLink}>{topicTitle}</TopicLink>
            {!!bylineText && (
                <>
                    <Bullet removeMargin={true} />
                    {!bylineLink ? (
                        <Author>{bylineText}</Author>
                    ) : (
                        <AuthorLink to={bylineLink}>{bylineText}</AuthorLink>
                    )}
                </>
            )}
            {allowCommenting && (
                <>
                    <Bullet removeMargin={true} />
                    <CommentsCount articleUrl={articleUrl} />
                </>
            )}
        </TopicBylineWrapper>
    )
}
